import { IndexTable, Page, Card } from "@shopify/polaris";
import { useHistory } from "react-router";
import { useQuery } from "react-query";

import Rows from "./Rows";
import { getAllReservationTypes } from "api";

export default function List(props) {
  const history = useHistory();

  const { data, isLoading } = useQuery("reservationTypes", () =>
    getAllReservationTypes("?isDeleted=false")
  );

  const resourceName = {
    singular: "Rezervasyon Türü",
    plural: "Rezervasyon Türleri",
  };

  const accounting = data || [];

  return (
    <Page
      title="Rezervasyon Türleri"
      primaryAction={{
        content: "Yeni Kayıt",
        onAction: () => history.push("/reservationTypes/new"),
      }}
    >
      <Card>
        <IndexTable
          selectable={false}
          loading={isLoading}
          lastColumnSticky
          resourceName={resourceName}
          itemCount={accounting.length}
          headings={[
            { title: "Başlık" },
            { title: "Açıklama" },
            { title: "Seçim Türü" },
            { title: "Seans Süresi" },
            { title: "Max Seans Adeti" },
            { title: "Durum" },
            { title: "" },
          ]}
        >
          <Rows data={accounting} />
        </IndexTable>
      </Card>
    </Page>
  );
}
